import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { useTranslation } from "react-i18next";

/**
 * v0.4.6 / A1+A5 — guards every protected route.
 *
 * - Not signed in → redirect to /login (carrying intended path).
 * - Signed in but `must_change_password=true` and target isn't
 *   /change-password → force the rotation screen.
 * - Optional `role` prop enforces role-based access (A3).
 *   A mismatched role → redirect to / with a 403 toast hint.
 */
export const AuthGate = ({ children, role }) => {
  const { t } = useTranslation();
  const { admin, loading } = useAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white dark:bg-slate-900 text-slate-600 dark:text-slate-300 tabular-nums text-sm">
        {t("ui.common.loading", { defaultValue: "loading…" })}
      </div>
    );
  }
  if (!admin) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }
  if (admin.must_change_password && loc.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  if (role && admin.role !== role) {
    return <Navigate to="/" state={{ forbidden: true }} replace />;
  }
  return children;
};
